import axios from "axios";
import { action, observable } from "mobx";
import moment from "moment";
import FileSaver from 'file-saver';
import { salt, sortByDate, languageContent } from "../@helpers";
import { Config } from "../config";

const content = languageContent();
const { component } = content;
const {
  form: { enterBasicHeight },
  datasets
} = component.GrowthCalculator;
const initDataSet = datasets[0].value;

const defaultSessionData = {
  Sex: "F",
  BirthDate: null,
  FatherHeight: null,
  MotherHeight: null,
  childTableData: [{ Id: salt() }],
  enterBasicHeight: enterBasicHeight
};

class GrowthCalculator {
  @observable isMetric = true;
  @observable accordionHeight = 0;
  @observable dataSet = initDataSet;
  @observable loadingData = false;
  @observable showHeight = true;
  @observable isCalculateTargetHeightClick = false;
  @observable showAbnormalWarning = false;
  @observable aboveHeight = false;
  @observable belowHeight = false;
  @observable showError = false;
  @observable disabledPDF = true;
  @observable errorMessage = [];
  @observable calculatedAge = null;
  @observable targetHeight = null;
  @observable targetHeightError = null;
  @observable dateOfBirthError = null;
  @observable sessionData = defaultSessionData;
  @observable iframeXML = null;
  @observable selectedDate = this.sessionData.childTableData[0].Date || null;
  @observable calculatorEndpoint =
    Config.endpoint.calculator[Config.environment];
  @observable imageStringHeight = null;
  @observable imageStringWeight = null;
  @observable wcdString = "M0";
  @observable graphType = "Height";
  @observable image = `${this.calculatorEndpoint}/${
    this.dataSet
  }/webcharts.com/graph.jpg/Height?wct=&wcd=${
    this.wcdString
  }&wcs=null&cachebust=${Date.now()}`;

  @action
  populate = name => {
    const endpoint = `${Config.endpoint.wordpress.base}${Config.endpoint.wordpress.lynx}${Config.endpoint.wordpress.navigation}/${name}`;
    axios.get(endpoint).then(response => {
      this.menu = response.data;
    });
  };

  @action
  setAccordionHeight = (value = "auto") => {
    this.accordionHeight = value;
  };

  @action
  handleChildDataWarnings = remoteMeasures => {
    remoteMeasures.map(remoteMeasure => {
      console.log(
        remoteMeasure,
        remoteMeasure.HeightWarning,
        remoteMeasure.WeightWarning,
        remoteMeasure.HeightRelativeValue
      );
      if (remoteMeasure.HeightWarning === "true") {
        console.info(`child is wrong height`);
        console.log(
          "remoteMeasure.HeightRelativeValue: ",
          remoteMeasure.HeightRelativeValue
        );
        console.log("YO", remoteMeasure.HeightRelativeValue);
        if (remoteMeasure.HeightRelativeValue < -2) {
          this.belowHeight = true;
          console.log("YO");
          window.dataLayer.push({
            event: "rangeTracker",
            rangeTrack: "under range"
          });
        }
        if (remoteMeasure.HeightRelativeValue > 2) {
          this.aboveHeight = true;
          window.dataLayer.push({
            event: "rangeTracker",
            rangeTrack: "over range"
          });
        }
        this.showAbnormalWarning = true;
      }
    });
  };

  @action
  clearAbnormalWarning = () => {
    this.belowHeight = false;
    this.aboveHeight = false;
    this.showAbnormalWarning = false;
    this.showError = false;
  };

  @action
  handleChangeDataSet = event => {
    this.dataSet =
      event.currentTarget.options[event.currentTarget.selectedIndex].value;
    const assetUrl = `${this.calculatorEndpoint}/${
      this.dataSet
    }/webcharts.com/graph.jpg/Height?wct=&wcd=${this.wcdString}&wcs=${
      this.selectedDate
    }&cachebust=${Date.now()}`;
    this.fetchCalculatorImage(assetUrl).then(data => {
      console.log("DATA:", data);
      this.image = data;
    });
  };

  @action
  handleReset = () => {
    this.sessionData = defaultSessionData;
    this.accordionHeight = 0;
    this.calculatedAge = null;
    this.targetHeight = null;
    this.targetHeightError = null;
    this.dateOfBirthError = null;
    this.image = false;
    this.isCalculateTargetHeightClick = false;
  };

  @action
  makeApiCall = data => {
    const endpoint = `${this.calculatorEndpoint}/${this.dataSet}/webcharts.com/child`;
    // Format the session data to be sent to the API
    const formattedData = this.formatDataForAPI(data);

    // Set up the ajax request
    let xhr = new XMLHttpRequest();
    xhr.withCredentials = false;
    xhr.open("POST", endpoint);
    xhr.setRequestHeader("content-type", "application/x-www-form-urlencoded");
    xhr.send(formattedData);

    return new Promise(resolve => {
      xhr.addEventListener("readystatechange", function() {
        if (this.readyState === this.DONE) {
          // Format the response
          const parsedResponse = JSON.parse(this.responseText);

          console.log("PARSED RESPONSE", parsedResponse);

          // Return the response
          resolve(parsedResponse);
        }
      });
    });
  };

  fetchCalculatorImage = async assetUrl => {
    let resp = await fetch(assetUrl, { credentials: "omit" });
    //console.log(resp.headers.get('content-type'));
    let blob = await resp.blob();
    let blobUrl = await URL.createObjectURL(blob);
    return blobUrl;
  };

  @action
  handleSubmit = (event = null) => {
    if (event) {
      event.preventDefault();
    }

    this.loadingData = true;
    this.makeApiCall(this.sessionData).then(response => {
      this.disabledPDF = false;
      this.loadingData = false;
      this.wcdString = response.GrowthCharts.Data;
      const assetUrl = `${this.calculatorEndpoint}/${
        this.dataSet
      }/webcharts.com/graph.jpg/Height?wct=&wcd=${this.wcdString}&wcs=${
        this.selectedDate
      }&cachebust=${Date.now()}`;
      this.fetchCalculatorImage(assetUrl).then(data => {
        this.image = data;
      });
      this.targetHeight = {
        metric: response.GrowthCharts.ChildData.TargetHeight,
        imperial: this.convertHeightMetricToImperial(
          response.GrowthCharts.ChildData.TargetHeight
        )
      };
      this.handleChildDataWarnings(response.GrowthCharts.ChildData.Measures);
    });
  };

  @action
  validateData = data => {
    const ieDetect = data.BirthDate.indexOf("/");

    if (ieDetect > 0) {
      var chars = data.BirthDate.split("/");
      data.BirthDate = chars[2] + "-" + chars[1] + "-" + chars[0];
    }

    data.childTableData.forEach((datum, index) => {
      if (datum.Date) {
        // datum.Date = datum.Date.replace(/\//g, '-');

        var input = datum.Date;
        // console.log(input);
        //
        const ieDetect = input.indexOf("/");
        // console.log(ieDetect);

        if (ieDetect > 0) {
          var chars = input.split("/");
          datum.Date = chars[2] + "-" + chars[1] + "-" + chars[0];
        }
      }
    });

    return data;
  };

  @action
  formatDataForAPI = sessionData => {
    const cleanData = this.validateData(sessionData);
    const connector = "\n";

    const splitDate = cleanData.BirthDate.split("-");

    let data = [
      `Sex=${cleanData.Sex || null}`,
      `BirthDateYYYY=${cleanData.BirthDate ? splitDate[0] : null}`,
      `BirthDateMM=${cleanData.BirthDate ? splitDate[1] : null}`,
      `BirthDateDD=${cleanData.BirthDate ? splitDate[2] : null}`,
      `FatherHeight=${
        cleanData.FatherHeight ? cleanData.FatherHeight.metric : 0
      }`,
      `MotherHeight=${
        cleanData.MotherHeight ? cleanData.MotherHeight.metric : 0
      }`
    ];

    if (cleanData.childTableData && cleanData.childTableData.length > 0) {
      cleanData.childTableData
        .slice()
        .sort(sortByDate)
        .forEach((datum, index) => {
          if (datum.Date) {
            const splitDate = datum.Date.split("-");

            const formattedDatum = [
              `DateYYYY${index}=${datum.Date ? splitDate[0] : null}`,
              `DateMM${index}=${datum.Date ? splitDate[1] : null}`,
              `DateDD${index}=${datum.Date ? splitDate[2] : null}`,
              `Selected${index}=false`,
              `Height${index}=${datum.Height ? datum.Height.metric : 0}`,
              `HeightRelativeValue${index}=-1.6`,
              `HeightWarning${index}=false`,
              `Weight${index}=${datum.Weight ? datum.Weight.metric : 0}`,
              `IsValidWeight${index}=false`,
              `WeightRelativeValue${index}=-8.3`,
              `WeightWarning${index}=false`,
              `BMI${index}=`,
              `BMIRelativeValue${index}=`
            ];
            data.push(formattedDatum.join(connector));
          }
        });
    }

    data = data.join(connector);

    return data;
  };

  @action
  toggleAccordion = () => {
    this.accordionHeight = this.accordionHeight === 0 ? "auto" : 0;
  };

  @action
  updateSessionData = event => {
    const key = event.currentTarget.id;
    const value = event.currentTarget.value;

    if (key.indexOf("Measures-") > -1) {
      const index = key.split(":")[1];
      const measurekey = key.split("-")[1].split(":")[0];
      let { childTableData } = this.sessionData;
      let formattedValue;

      if (key.indexOf("Height") > -1) {
        formattedValue = this.createHeightObject(value);
      } else if (key.indexOf("Weight") > -1) {
        formattedValue = this.createWeightObject(value);
      } else {
        formattedValue = value;
      }

      childTableData[index][measurekey] = formattedValue;
      this.sessionData = { ...this.sessionData, childTableData };
      return;
    }
    if (key.indexOf("Height") > -1) {
      this.sessionData = {
        ...this.sessionData,
        [key]: this.createHeightObject(value)
      };
      return;
    }
    this.sessionData = { ...this.sessionData, [key]: value };
  };

  @action
  calculateCurrentAge = event => {
    var input = event.currentTarget.value;
    // console.log(input);
    //
    const ieDetect = input.indexOf("/");
    // console.log(ieDetect);

    if (ieDetect > 0) {
      var chars = input.split("/");
      input = chars[2] + "-" + chars[1] + "-" + chars[0];
    }

    const BirthDate = moment(input);
    const now = moment();
    const diffInYears = now.diff(BirthDate, "years");
    const diffInMonths = now.diff(BirthDate, "months") - diffInYears * 12;
    this.calculatedAge = {
      years: diffInYears,
      months: diffInMonths
    };
  };

  @action
  handleSaveData = () => {
    const assetUrl = `${this.calculatorEndpoint}/${
      this.dataSet
    }/webcharts.com/child.xml?wct=&wcd=${this.wcdString}&wcs=${
      this.selectedDate
    }&cachebust=${Date.now()}`;

    this.fetchCalculatorAsset(assetUrl).then(async (data) => {
      FileSaver.saveAs(data, 'GrowthChart.xml');
    });
  };

  @action
  handleDownloadPDF = () => {
    let assetUrl = `${this.calculatorEndpoint}/${
      this.dataSet
    }/webcharts.com/report.pdf?wct=&wcd=${this.wcdString}&wcs=${
      this.selectedDate
    }&cachebust=${Date.now()}`;

    this.fetchCalculatorAsset(assetUrl).then(async (data) => {
      FileSaver.saveAs(data, 'GrowthReport.pdf');
    });
  };

  fetchCalculatorAsset = async assetUrl => {
    let resp = await fetch(assetUrl, { credentials: "omit" });
    //console.log(resp.headers.get('content-type'));
    let blob = await resp.blob();

    return blob;
  };

  forceDownload = async (assetFile, downloadName) => {
    const forceDownload = document.createElement("a");
    forceDownload.style.display = "none";
    document.body.appendChild(forceDownload);
    forceDownload.href = assetFile;
    forceDownload.setAttribute("download", downloadName);
    forceDownload.click();
    window.URL.revokeObjectURL(forceDownload.href);
    document.body.removeChild(forceDownload);
  };

  @action
  handleSwitchGraph = () => {
    this.showHeight = !this.showHeight;

    this.graphType = this.showHeight ? "Height" : "Weight";

    const assetUrl = `${this.calculatorEndpoint}/${
      this.dataSet
    }/webcharts.com/graph.jpg/${this.graphType}?wct=&wcd=${
      this.wcdString
    }&wcs=${this.selectedDate}&cachebust=${Date.now()}`;
    this.fetchCalculatorImage(assetUrl).then(data => {
      this.image = data;
    });
    console.log("GRAPH TYPE:", this.graphType);
  };

  @action
  addNewRow = () => {
    let { childTableData } = this.sessionData;
    childTableData.push({
      Id: salt()
    });
    this.sessionData = { ...this.sessionData, childTableData };
  };

  @action
  deleteRow = id => {
    const childTableData = this.sessionData.childTableData.filter(
      datum => datum.Id !== id
    );

    if (childTableData.length !== 0) {
      this.sessionData = { ...this.sessionData, childTableData };
    } else {
      this.sessionData.childTableData = [
        { Id: salt(), Date: null, Height: null, Weight: null }
      ];
    }
  };

  createHeightObject = value => {
    return {
      metric: this.isMetric ? value : this.convertHeightImperialToMetric(value),
      imperial: this.isMetric
        ? this.convertHeightMetricToImperial(value)
        : value
    };
  };

  createWeightObject = value => {
    return {
      metric: this.isMetric ? value : this.convertWeightImperialToMetric(value),
      imperial: this.isMetric
        ? this.convertWeightMetricToImperial(value)
        : value
    };
  };

  getUnit = () => {
    return this.isMetric ? "metric" : "imperial";
  };

  @action
  handleToggleIsMetric = () => {
    this.isMetric = !this.isMetric;
  };

  @action
  calculateTargetHeight = () => {
    const { FatherHeight, MotherHeight } = this.sessionData;
    let hasBothValues = true;
    let birthDateNotEmpty = true;

    if (FatherHeight && MotherHeight) {
      if (FatherHeight.metric === "" || MotherHeight.metric === "") {
        hasBothValues = false;
      }
    } else {
      hasBothValues = false;
    }

    if (this.sessionData.BirthDate === null) {
      birthDateNotEmpty = false;
    }

    if (!hasBothValues) {
      this.targetHeightError = "Please enter the basic information first.";
      this.targetHeight = null;
      console.error(`!hasBothValues`, hasBothValues);
    }

    if (!birthDateNotEmpty) {
      this.dateOfBirthError = "Please enter a Date of Birth.";
    } else {
      this.dateOfBirthError = "";
    }

    if (hasBothValues && birthDateNotEmpty) {
      this.targetHeightError = null;
      this.dateOfBirthError = null;

      this.makeApiCall(this.sessionData).then(response => {
        this.targetHeight = {
          metric: response.GrowthCharts.ChildData.TargetHeight,
          imperial: this.convertHeightMetricToImperial(
            response.GrowthCharts.ChildData.TargetHeight
          )
        };
      });
    }
  };

  @action
  triggerUpload = fileUploader => {
    fileUploader.click();
  };

  @action
  formatDate = date => {
    return date
      .split("-")
      .reverse()
      .join("/");
  };

  @action
  handleUpload = (files, refs) => {
    if (files[0].type === "text/xml") {
      const reader = new FileReader();

      reader.onload = file => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(file.target.result, "text/xml");

        var formattedBirthDate = this.formatDate(
          xmlDoc.getElementsByTagName("ChildData")[0].attributes["BirthDate"]
            .value
        );

        const page = document.getElementsByClassName("page");
        const classlist = page[0].getAttribute("class");

        const unformatted = xmlDoc.getElementsByTagName("ChildData")[0]
          .attributes["BirthDate"].value;
        const formatted = this.formatDate(
          xmlDoc.getElementsByTagName("ChildData")[0].attributes["BirthDate"]
            .value
        );

        if (classlist.indexOf("browser-ie") > -1) {
          formattedBirthDate = formatted;
        } else {
          formattedBirthDate = unformatted;
        }

        const newSessionData = {
          Sex: xmlDoc.getElementsByTagName("ChildData")[0].attributes["Sex"]
            .value,
          BirthDate: formattedBirthDate,
          FatherHeight: this.createHeightObject(
            xmlDoc.getElementsByTagName("ChildData")[0].attributes[
              "FatherHeight"
            ].value
          ),
          MotherHeight: this.createHeightObject(
            xmlDoc.getElementsByTagName("ChildData")[0].attributes[
              "MotherHeight"
            ].value
          ),
          childTableData: []
        };

        refs.BirthDate.value = newSessionData.BirthDate;
        refs.Sex.value = newSessionData.Sex;

        const len = xmlDoc.getElementsByTagName("Measures")[0].childNodes
          .length;
        for (let i = 0; i < len; i++) {
          if (
            xmlDoc.getElementsByTagName("Measures")[0].childNodes[i]
              .nodeName === "Measure"
          ) {
            var newDate = "";
            const unformatted = xmlDoc.getElementsByTagName("Measures")[0]
              .childNodes[i].attributes["Date"].value;
            const formatted = this.formatDate(
              xmlDoc.getElementsByTagName("Measures")[0].childNodes[i]
                .attributes["Date"].value
            );

            if (classlist.indexOf("browser-ie") > -1) {
              newDate = formatted;
            } else {
              newDate = unformatted;
            }

            newSessionData.childTableData.push({
              Id: salt(),
              Date: newDate,
              Height: this.createHeightObject(
                xmlDoc.getElementsByTagName("Measures")[0].childNodes[i]
                  .attributes["Height"].value
              ),
              Weight: this.createWeightObject(
                xmlDoc.getElementsByTagName("Measures")[0].childNodes[i]
                  .attributes["Weight"].value
              )
            });
          }
        }

        if (newSessionData.childTableData.length === 0) {
          newSessionData.childTableData.push({ Id: salt() });
        }

        this.sessionData = newSessionData;
        this.handleSubmit();
      };

      reader.readAsText(files[0]);
    }
  };

  convertHeightMetricToImperial = input => (input * 0.393700779).toFixed(2); // cm to in
  convertHeightImperialToMetric = input => (input * 2.54).toFixed(2); // in to cm
  convertWeightMetricToImperial = input => (input * 2.20462262).toFixed(2); // kg to lb
  convertWeightImperialToMetric = input => (input * 0.45359237).toFixed(2); // lb to kg
}
const GrowthCalculatorStore = new GrowthCalculator();
export default GrowthCalculatorStore;
